var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0d1a2e;\n      }\n\n      .cls-2 {\n        fill: #d9d9d9;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300,
    cy: 300,
    r: 300
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.76,432.98h20.61v86.09c0,1.34-1.09,2.43-2.43,2.43h-15.75c-1.34,0-2.43-1.09-2.43-2.43v-86.09h0Z",
    transform: "translate(296.32 -103.57) rotate(31.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 352.6,
    y: 426.96,
    width: 13.88,
    height: 13.43,
    transform: "translate(277.54 -123.66) rotate(31.29)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.72,441.36c-13.65,0-27.08-3.73-39.04-11-17.22-10.46-29.33-27.01-34.1-46.58-4.78-19.57-1.64-39.83,8.82-57.05,10.46-17.22,27.01-29.33,46.58-34.1,19.57-4.77,39.83-1.64,57.05,8.82,17.22,10.46,29.33,27.01,34.1,46.58,4.78,19.57,1.64,39.83-8.82,57.05-10.46,17.22-27.01,29.33-46.58,34.1-5.98,1.46-12.02,2.18-18.01,2.18ZM400.98,296.94c-5.48,0-11,.66-16.46,1.99-17.89,4.36-33.01,15.43-42.57,31.17-9.56,15.74-12.43,34.26-8.06,52.15,4.36,17.89,15.43,33.01,31.17,42.57,15.74,9.56,34.26,12.43,52.14,8.06,36.93-9.01,59.65-46.38,50.64-83.31-4.36-17.89-15.43-33.01-31.17-42.57-10.93-6.64-23.21-10.06-35.68-10.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.43,362.77c-.13,0-.25,0-.38-.02-1.78-.21-3.05-1.82-2.84-3.6,2.81-23.96,20.45-43.9,43.9-49.62,1.74-.43,3.49.64,3.92,2.38.42,1.74-.64,3.49-2.38,3.92-20.83,5.08-36.5,22.79-39,44.08-.19,1.65-1.59,2.86-3.22,2.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.52,304.8c-1.79,0-3.24-1.45-3.24-3.24v-109.98c0-1.79,1.45-3.24,3.24-3.24s3.24,1.45,3.24,3.24v109.98c0,1.79-1.45,3.24-3.24,3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.52,482.81H142.95c-1.79,0-3.24-1.45-3.24-3.24V116.81c0-1.79,1.45-3.24,3.24-3.24h198.58c1.79,0,3.24,1.45,3.24,3.24s-1.45,3.24-3.24,3.24h-195.34v356.28h284.09v-46.06c0-1.79,1.45-3.24,3.24-3.24s3.24,1.45,3.24,3.24v49.3c0,1.79-1.45,3.24-3.24,3.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.55,188.61h-107.31c-1.79,0-3.24-1.45-3.24-3.24s1.45-3.24,3.24-3.24h107.31c1.79,0,3.24,1.45,3.24,3.24s-1.45,3.24-3.24,3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.34,230.77h-215.11c-1.79,0-3.24-1.45-3.24-3.24s1.45-3.24,3.24-3.24h215.11c1.79,0,3.24,1.45,3.24,3.24s-1.45,3.24-3.24,3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.34,272.93h-215.11c-1.79,0-3.24-1.45-3.24-3.24s1.45-3.24,3.24-3.24h215.11c1.79,0,3.24,1.45,3.24,3.24s-1.45,3.24-3.24,3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.12,315.09h-117.88c-1.79,0-3.24-1.45-3.24-3.24s1.45-3.24,3.24-3.24h117.88c1.79,0,3.24,1.45,3.24,3.24s-1.45,3.24-3.24,3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.12,357.26h-117.88c-1.79,0-3.24-1.45-3.24-3.24s1.45-3.24,3.24-3.24h117.88c1.79,0,3.24,1.45,3.24,3.24s-1.45,3.24-3.24,3.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.35,209.3c-35.01,0-63.49-28.48-63.49-63.49s28.48-63.49,63.49-63.49,63.49,28.48,63.49,63.49-28.48,63.49-63.49,63.49ZM394.35,88.8c-31.43,0-57,25.57-57,57s25.57,57,57,57,57-25.57,57-57-25.57-57-57-57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.32,168.12c-.83,0-1.66-.32-2.29-.95l-18.67-18.67c-1.27-1.27-1.27-3.32,0-4.59,1.26-1.27,3.32-1.27,4.58,0l16.37,16.37,35.85-35.85c1.26-1.27,3.32-1.27,4.58,0,1.27,1.27,1.27,3.32,0,4.59l-38.15,38.15c-.63.63-1.46.95-2.29.95Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysePlaceholder);
export default __webpack_public_path__ + "static/media/AnalysePlaceholder.0770c294e864220e3358a4f3d21fe746.svg";
export { ForwardRef as ReactComponent };